import { CompanyInformationClientProposalFragment } from '../../../../../../lib/graphql'

export enum OWNER_PROPOSAL_BUTTON_CLICK_ENUM {
  REFUSE = 'REFUSE',
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  CONFIRMATION = 'CONFIRMATION',
}

export const onUploadFile = ({
  event,
  onUploadFile,
  setFileName,
  setFileUrl,
}: {
  event: React.ChangeEvent<HTMLInputElement>
  onUploadFile?: (formData: FormData) => void
  setFileName: React.Dispatch<React.SetStateAction<string | undefined>>
  setFileUrl?: React.Dispatch<React.SetStateAction<string | undefined>>
}) => {
  const file = event.target.files ? event.target.files[0] : null

  if (file) {
    const formData = new FormData()
    formData.append('file', file)

    const fileUrl = URL.createObjectURL(file)
    setFileUrl && setFileUrl(fileUrl)
    setFileName(file.name)

    onUploadFile && onUploadFile(formData)
  }
}

export const clearFile = ({
  setFileName,
  setFileUrl,
}: {
  setFileName: React.Dispatch<React.SetStateAction<string | undefined>>
  setFileUrl:
    | React.Dispatch<React.SetStateAction<string | undefined>>
    | undefined
}) => {
  setFileName(undefined)
  setFileUrl && setFileUrl(undefined)
}

export const getFileProps = ({
  clientProposal,
}: {
  clientProposal: CompanyInformationClientProposalFragment
}) => {
  if (clientProposal.house) {
    return {
      entityName: 'house',
      title: clientProposal.house.title,
    }
  } else if (clientProposal.serviceProvider) {
    return {
      entityName: 'serviceProvider',
      title: clientProposal.serviceProvider.title,
    }
  }

  throw new Error('HOUSE_OR_SERVICE_PROVIDER_REQUIRED')
}
